import React from 'react';

// FU-002A (2026-05-27): the top-level `/athena/admin/configuration`
// route (tenant-wide configuration template) was retired. The page is
// still reachable as a per-project tab via the workspace
// (`?tab=configuration`), which mounts ConfigurationProvider with a
// sessionId. The empty fragment keeps the feature-folder convention
// (every feature exports `routes.jsx`) without resurrecting a dead URL.
export const adminConfigurationRoutes = <></>;
